<section class="admission-update-section" *ngIf="admissionDescription;">

  <!-- ================= HEADER ================= -->

  <div class="section-header">

    <h2 class="main-title">
      ADMISSION UPDATE
    </h2>

    <p class="subtitle">
      Stay up to date with the latest admission news and announcements.
    </p>

  </div>

  <!-- ================= CASE 1 : CMS DATA EXISTS ================= -->

  <ng-container *ngIf="admissionDescription;">

    <div class="admission-card">

      <!-- IMAGE -->

      <div class="image-wrapper">

        <img
          *ngIf="admissionImage"
          [src]="admissionImage"
          alt="Admission Update">

      </div>

      <!-- CONTENT -->

      <div class="content-wrapper">

        <span class="badge">
          Admission
        </span>

        <h3 class="session-title">
          {{ admissionDescription?.pageTitle || '2026-27' }}
        </h3>

        <div
          class="description"
          [innerHTML]="admissionDescription?.content || ''">
        </div>

        <div class="footer-row">

          <div class="posted-date">
            Posted on:
            {{ admissionPostedDate?.content || 'DD-MM-YYYY' }}
          </div>

          <button
            class="update-btn"
            (click)="viewUpdate()">

            View Update

          </button>

        </div>

      </div>

    </div>

  </ng-container>

  <!-- ================= CASE 2 : FALLBACK UI ================= -->

  <!-- <ng-template #defaultAdmissionUpdate>

    <div class="admission-card">



      <div class="image-wrapper">

        <img
          src="assets/Homepage/admission-update.jpg"
          alt="Admission Update">

      </div>



      <div class="content-wrapper">

        <span class="badge">
          Admission
        </span>

        <h3 class="session-title">
          2026-27
        </h3>

        <div class="description">

          Registration forms for admission in Nursery,
          KG-I, KG-II & Std. I can be filled and submitted
          online through the school’s official website.

          Online registration form (2026-27) is also
          available for provisional admission in Std. XI
          (Science, Commerce & Humanities).

        </div>

        <div class="footer-row">

          <div class="posted-date">
            Posted on: 2025-09-15
          </div>

          <button class="update-btn">
            View Update
          </button>

        </div>

      </div>

    </div>

  </ng-template> -->

</section>